import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  ngOnInit(): void {
    this.hideLoadingScreen();
  }

  private hideLoadingScreen(): void {
    const loadingEl = document.getElementById('app-loading');
    if (loadingEl) {
      loadingEl.remove();
    }
  }
}
